import React, {useEffect, useState} from 'react';
import {Accordion} from '../Accordion/LocalizedAccordion';
import {t} from 'i18next';
import {DropdownInput, LocaleSelection} from './LocalePicker.style';
import {createLocale, isNullOrEmpty} from '../../utils';
import {generateIdentifier} from '../../utils/IdentityUtils';
import {config} from '../../init/config';
import {DropdownMultipleValueProps, DropdownOptionProps} from '../../models/DropdownProps';
import {
    DROPDOWN_OPTION,
    getDropdownOptionProps,
    getEmptyDropdownOptionProps,
    SELECT_LOCALE
} from '../../utils/DropdownOptionPropsUtils';

export const LocalePicker: React.VFC<DropdownMultipleValueProps<string>> = (props) => {
    const getOptions = (localeSelectionState: string[]): DropdownOptionProps[] => {
        let options: DropdownOptionProps[] = [];
        let localeItem: DropdownOptionProps = getEmptyDropdownOptionProps(SELECT_LOCALE, SELECT_LOCALE, DROPDOWN_OPTION);
        options.push(localeItem);
        props.dataSource.filter(locale => (isNullOrEmpty(locale.value) || (!localeSelectionState.includes(locale.value))))
            .map(locale => options.push(locale));

        return getDropdownOptionProps(options, SELECT_LOCALE, DROPDOWN_OPTION);
    };

    const getLocaleSelection = (localeSelectionState: string[]): string[] => {
        let localeSelection: string[] = [];
        let localeItem: string[] = [];
        if (localeSelectionState) {
            localeSelectionState.map(locale => {
                if (locale) {
                    localeItem = locale.split('/');
                    if ((localeItem) && (localeItem.length >= 3)) {
                        if (config.SWAP_COUNTRY_LANGUAGE_ACTIVE) {
                            localeSelection.push(createLocale(localeItem[1], localeItem[2]));
                        } else {
                            localeSelection.push(createLocale(localeItem[2], localeItem[1]));
                        }
                    }
                }
            });
        }

        return localeSelection;
    };

    const [localeSelection, setLocaleSelection] = useState<string[]>([]);
    const [localeInput, setLocaleInput] = useState<string>(props.defaultValue ? props.defaultValue : '');
    const [localeOptions, setLocaleOptions] = useState<DropdownOptionProps[]>(getOptions([]));

    const setState = (selectionState: string[], selectionOptions: DropdownOptionProps[], resetInput: boolean) => {
        setLocaleSelection(selectionState);
        props.onChange(getLocaleSelection(selectionState));
        setLocaleOptions(selectionOptions);
        if (resetInput) {
            setLocaleInput('');
        }
    };

    useEffect(() => {
        setLocaleOptions(getOptions([]));
    }, [props.dataSource]);

    useEffect(() => {
        if (props.resetState) {
            setState([], getOptions([]), true);
        }
    }, [props.resetState]);

    const handleInput = (e: React.ChangeEvent<HTMLSelectElement>) => {
        let eventValue = e.target.value.toString();
        setLocaleInput(eventValue);
        let selectionOptions = localeOptions;
        let selectionState = [eventValue];
        if (props.resetInput) {
            selectionOptions = localeOptions.filter(locale => (locale.value !== eventValue));
            selectionState = [...localeSelection];
            if (!localeSelection.includes(eventValue)) {
                selectionState = selectionState.concat(eventValue);
            }
        }
        setState(selectionState, selectionOptions, props.resetInput);
    };

    const handleDelete = (localeKey: string) => {
        let selectionState = localeSelection.filter(locale => (locale !== localeKey));
        setState(selectionState, getOptions(selectionState), true);
    };

    const getLabel = (locale: string) => {
        let label = '';
        if (locale) {
            label = locale;
        }

        return label;
    };

    return (
        <Accordion localizedHeadline={t('LOCALE_PICKER_CAPTION')}>
            <DropdownInput id={generateIdentifier('localeId_'.concat(localeInput))}
                           defaultValue={props.defaultValue ? props.defaultValue : ''}
                           value={localeInput}
                           options={localeOptions}
                           disabled={props.disabled}
                           onChange={handleInput}/>
            {localeSelection?.map(locale => {
                return props.resetInput &&
                    <LocaleSelection id={generateIdentifier(locale)}
                                     key={locale}
                                     label={getLabel(locale)}
                                     buttonClose
                                     onClose={() => handleDelete(locale)}/>;
            })}
        </Accordion>
    );
};
